module.exports = __webpack_public_path__ + "static/img/bofang2.a383b8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/bofang2.png
// module id = QwNU
// module chunks = 24